package nl.volleyplanner.api.client

import io.ktor.client.call.*
import io.ktor.client.request.*
import io.ktor.http.*
import nl.volleyplanner.api.volleyanalyzer.PouleListResponse
import nl.volleyplanner.api.volleyanalyzer.PouleMatchesResponse
import nl.volleyplanner.api.sports.BasicPoule

class VolleyanalyzerApiClient(
    private val defaultRequestSpec: ApiDefaultRequestSpec
) : BaseApiClient(defaultRequestSpec, additionalConfigBlock = null) {
    companion object {
        val DEV_SPEC = ApiDefaultRequestSpec(
            "localhost", 8080, URLProtocol.HTTP
        )
        val PRODUCTION_SPEC = ApiDefaultRequestSpec(
            "volleyplanner-api-server-unvcca7s3q-ew.a.run.app", null, URLProtocol.HTTPS
        )
    }

    suspend fun getAnalyzerPoules() : PouleListResponse {
        return httpClient.get("/volleyanalyzer/poule/list").body()
    }

    suspend fun getBasicPoule(pouleId: String) : BasicPoule {
        return httpClient.get("/volleyanalyzer/poule/$pouleId").body()
    }

    suspend fun getPouleMatches(pouleId: String, forceRefresh: Boolean) : PouleMatchesResponse {
        val refreshUrl = if (forceRefresh) "?force_refresh=true" else ""
        return httpClient.get("/volleyanalyzer/poule/$pouleId/matches$refreshUrl").body()
    }
}